export const IMGIX_PRODUCT_IMAGE_WIDTH = 148;
export const IMGIX_PRODUCT_IMAGE_HEIGHT = 148;
